import { useTranslation } from 'react-i18next';

export type DanceStyle = {
  id: string;
  name: string;
  accent: 'wine' | 'verde' | 'ember' | 'gold';
  midnight?: boolean;
  kicker: string;
  history: string;
  signature: string[];
  steckbrief: { label: string; value: string }[];
};

type StyleStatic = Pick<DanceStyle, 'accent' | 'midnight'>;

const STYLE_STATIC: Record<string, StyleStatic> = {
  'brazilian-zouk': { accent: 'wine', midnight: true },
  'samba-de-gafieira': { accent: 'verde' },
};

type StyleEntry = Omit<DanceStyle, 'accent' | 'midnight'>;

export function useDanceStyles(): DanceStyle[] {
  const { t } = useTranslation();
  const entries = t('info.styles', { returnObjects: true }) as StyleEntry[];
  return entries.map((e) => ({ ...STYLE_STATIC[e.id], ...e }));
}

export type FirstClassTip = { n: string; title: string; body: string };

export function useFirstClassTips(): FirstClassTip[] {
  const { t } = useTranslation();
  return t('info.firstClassTips', { returnObjects: true }) as FirstClassTip[];
}

export type GlossarItem = { term: string; lang: string; def: string };

export function useGlossar(): GlossarItem[] {
  const { t } = useTranslation();
  return t('info.glossar.items', { returnObjects: true }) as GlossarItem[];
}
